import type {
  Message,
  MessageDisplaySummary,
  MessageActivityEvent,
} from "./index.js";

/** Providers expose chronological text/tool events; the trailing text is the answer. */
export function messageDisplaySummary(
  message: Pick<
    Message,
    | "content"
    | "reasoning"
    | "toolEvents"
    | "activityEvents"
    | "displaySummary"
    | "activityDeferred"
  >,
): MessageDisplaySummary {
  if (message.activityDeferred && message.displaySummary)
    return message.displaySummary;
  let finalContent = message.content;
  let finalTextEventId: string | null = null;
  let textCount = 0;
  let otherCount = 0;
  for (const event of message.activityEvents ?? []) {
    if (event.type === "text") {
      textCount++;
      finalContent = activityText(message.content, event);
      finalTextEventId = event.id;
    } else {
      otherCount++;
      if (event.type === "tool") {
        finalContent = "";
        finalTextEventId = null;
      }
    }
  }
  if (!textCount) finalContent = message.content;
  return {
    finalContent,
    finalTextEventId,
    hasActivity:
      otherCount > 0 ||
      textCount > 1 ||
      Boolean(message.reasoning) ||
      Boolean(message.toolEvents?.length),
    todoToolEvents: (message.toolEvents ?? [])
      .filter((event) => event.name === "update_todo_list")
      .slice(-1),
  };
}

function activityText(
  content: string,
  event: Extract<MessageActivityEvent, { type: "text" }>,
) {
  return event.contentRange
    ? content.slice(event.contentRange.start, event.contentRange.end)
    : event.content;
}
